import { render, staticRenderFns } from "./PlaceModal.vue?vue&type=template&id=9c754cf8&"
import script from "./PlaceModal.vue?vue&type=script&setup=true&lang=ts&"
export * from "./PlaceModal.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9c754cf8')) {
      api.createRecord('9c754cf8', component.options)
    } else {
      api.reload('9c754cf8', component.options)
    }
    module.hot.accept("./PlaceModal.vue?vue&type=template&id=9c754cf8&", function () {
      api.rerender('9c754cf8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "www/vue_components/common/TheFilters/lpu/components/PlaceFilters/components/PlaceModal.vue"
export default component.exports